/**
 * Shows a list of users which are registered for the application.
 * Material design: Table from https://material-ui.com/components/tables/#table
 */

import React from 'react'
import {Avatar} from "@mui/material";


const UserProfilePicture = ({user, height, width}) => {

    if (!user) {
        return <Avatar style={{height: height, width: width}}>
            N
        </Avatar>
    }

    return user.profilePicture
        ? <Avatar style={{height: height, width: width}}>
            <img style={{height: height, width: width}}
                 src={user.profilePicture}
                 alt={'Profile picture of ' + user.displayName}
                 referrerPolicy="no-referrer"/>
        </Avatar>
        : <Avatar style={{
            height: height,
            width: width
        }}>{user.firstName ? user.firstName.charAt(0) : user.displayName?.charAt(0)}
        </Avatar>
}
export default UserProfilePicture